import React from 'react';
import { Icon } from '@doxyme/ui';
import './ParticipantPublisherErrorMini.scss';
const ParticipantPublisherErrorMini = ({ message, }) => (<div className="react-pp-error-mini">
    <div className="react-pp-error-mini__content">
      <Icon name="call-video-off" className="react-pp-error-mini__icon" size="small"/>
      <div className="react-pp-error-mini__message">{message}</div>
    </div>
  </div>);
export default ParticipantPublisherErrorMini;
